async function checkOrder(id) {
    try {
        const response = await fetch(`/api/order/${id}/check`);

        if (response.status !== 200) return false;

        const { payload } = await response.json();

        return payload;
    } catch (error) {
        return true;
    }
}

export default checkOrder;